import * as CellType from '../components/CellType';
import { FORMATTED } from '../constants';

//#region Listas gerais
export const linesListColumns = [
    { id: 0, fieldName: 'nuLinha', title: 'Linha' },
    { id: 1, fieldName: 'deDescricao', title: 'Nome da linha' },
    { id: 2, fieldName: 'boAtivo', title: 'Inativo', align: 'right', Component: CellType.OfActive },
];

export const linesStripListColumns = [
    { id: 0, fieldName: 'nuLinha', title: 'Linha' },
    { id: 1, fieldName: 'deDescricao', title: 'Nome da linha' },
    { id: 2, fieldName: 'deRazaoSocial', title: 'Empresa' },
    { id: 3, fieldName: 'boAtivo', title: 'Inativo', align: 'right', Component: CellType.OfActive },
];

export const permissionariesColumns = [
    { id: 0, fieldName: 'deNomePermissionario', title: 'Nome permissionário', style: { maxWidth: '200px' } },
    { id: 1, fieldName: 'dePendencias', title: 'Pendências', Component: CellType.OfPendencies },
    { id: 2, fieldName: 'nuPermissionario', title: 'Nº cadastro' },
    {
        id: 3,
        fieldName: 'deCpfCnpj',
        title: 'CPF/CNPJ',
        Component: CellType.OfDocumentNumber,
        style: { minWidth: '170px' },
    },
    { id: 6, fieldName: 'nuCepeFmt', title: 'Nº CEPE', style: { minWidth: '120px' } },
    { id: 4, fieldName: 'deNomeCondutorSubstituto', title: 'Condutor substituto' },
    { id: 5, fieldName: 'boAtivo', title: 'Inativo', Component: CellType.OfActive },
];

export const itineraryListColumns = [
    { id: 0, fieldName: 'cdRevisao', title: 'Cod.' },
    { id: 1, fieldName: 'dtCadastro', title: 'Data de Cadastro' },
    { id: 2, fieldName: 'deTipoItinerario', title: 'Tipo de itinerário' },
    { id: 3, fieldName: 'deLinhaSituacao', title: 'Situação' },
];

export const scheduleListColumns = [
    { id: 0, fieldName: 'cdRevisao', title: 'Cod.' },
    { id: 4, fieldName: 'nuApostila', title: 'Nº Apostila' },
    { id: 1, fieldName: 'dtCadastro', title: 'Cadastro' },
    { id: 2, fieldName: 'dtVigencia', title: 'Vigência' },
    { id: 3, fieldName: 'deLinhaSituacao', title: 'Situação' },
];

export const fareListColumns = [
    { id: 0, fieldName: 'nuValor', title: 'Tarifa', Component: CellType.OfCurrency },
    { id: 1, fieldName: 'dtEmissao', title: 'Data emissão' },
    { id: 2, fieldName: 'dtValidade', title: 'Data validade' },
    { id: 3, fieldName: 'nuProcesso', title: 'Processo' },
    { id: 7, fieldName: 'boVigente', title: 'Vigente', Component: CellType.OfActive },
];
//#endregion

//#region Tela de detalhes de permissionários
export const permissionaryVehicleListColumns = [
    { id: 0, fieldName: 'veiculo.dePlaca', title: 'Placa', Component: CellType.OfNestedObjectV2, classes: ['nowrap'] },
    {
        id: 1,
        fieldName: 'veiculo.deRenavam',
        title: 'Renavam',
        Component: CellType.OfNestedObjectV2,
        classes: ['nowrap'],
    },
    {
        id: 2,
        fieldName: 'veiculo.deCpfCnpjProprietario',
        title: 'CPF / CNPJ proprietário',
        format: FORMATTED.document,
        Component: CellType.OfNestedObjectV2,
    },
    {
        id: 3,
        fieldName: 'veiculo.nmProprietario',
        title: 'Nome proprietário',
        Component: CellType.OfNestedObjectV2,
    },
    {
        id: 4,
        fieldName: 'veiculo.dtVencimentoVistoria',
        title: 'Venc. da Vistoria',
        Component: CellType.OfOptionalDate,
    },
    { id: 5, fieldName: 'boAtivo', title: 'Ativo', Component: CellType.OfSelect },
    { id: 6, fieldName: 'deObservacaoInativacao', title: '', Component: CellType.OfDetails },
];

export const permiSubstituteConductorColumns = [
    { id: 0, fieldName: 'deCpf', title: 'CPF', Component: CellType.OfDocumentNumber },
    { id: 1, fieldName: 'deNome', title: 'Nome' },
    { id: 2, fieldName: 'nuCondutor', title: 'Nº de identificação' },
    { id: 3, fieldName: 'tpCategoriaCnh', title: 'Categoria' },
    { id: 4, fieldName: 'dtValidade', title: 'Data vencimento', Component: CellType.OfDate },
];

export const substituteConductorColumns = [
    { id: 0, fieldName: 'deCpf', title: 'CPF', Component: CellType.OfDocumentNumber },
    { id: 1, fieldName: 'deNome', title: 'Nome' },
    { id: 2, fieldName: 'nuCondutor', title: 'Nº de identificação' },
    { id: 3, fieldName: 'tpCategoriaCnh', title: 'Categoria' },
    { id: 4, fieldName: 'dtValidade', title: 'Data vencimento', Component: CellType.OfDate },
    { id: 5, fieldName: 'boAtivo', title: 'Ativo', Component: CellType.OfActive },
];

export const adictiveColumns = [
    {
        id: 0,
        fieldName: 'tipoDocumento.deTipoDocumento',
        title: 'Tipo de termo',
        Component: CellType.OfNestedObjectV2,
    },
    { id: 1, fieldName: 'dtPublicacao', title: 'Data publicação', Component: CellType.OfDate },
    { id: 2, fieldName: 'nuAditivo', title: 'Número aditivo' },
];

export const attachmentColumns = [
    {
        id: 2,
        fieldName: 'tipoDocumento',
        title: 'Tipo de documento',
        Component: CellType.OfSelectDocumentInput,
    },
    {
        id: 1,
        fieldName: 'documentos.fileName',
        title: 'Arquivos',
        Component: CellType.OfDocumentField,
    },
];

export const substituteConductorDrawerColumns = [
    { id: 6, fieldName: 'cdCondutorSubstituto', title: '', Component: CellType.OfRadio },
    { id: 0, fieldName: 'deNome', title: 'Nome permissionário' },
    { id: 2, fieldName: 'nuCondutor', title: 'Nº cadastro' },
    { id: 3, fieldName: 'deCpf', title: 'CPF' },
    { id: 4, fieldName: 'deLinha', title: 'Linha' },
];

export const vehicleDrawerColumns = [
    { id: 6, fieldName: 'cdVeiculo', title: '', Component: CellType.OfRadioV2 },
    { id: 0, fieldName: 'dePlaca', title: 'Placa' },
    { id: 1, fieldName: 'deRenavam', title: 'Renavam' },
    {
        id: 2,
        fieldName: 'deCpfCnpjProprietario',
        title: 'CPF / CNPJ proprietário',
        Component: CellType.OfDocumentNumber,
    },
    { id: 3, fieldName: 'nmProprietario', title: 'Nome proprietário' },
    {
        id: 4,
        fieldName: 'dtVencimentoVistoria',
        title: 'Venc. da Vistoria',
        Component: CellType.OfOptionalDate,
    },
];

export const selectPermissionaryColumn = [
    { id: 4, fieldName: 'deCpfCnpj', title: '', Component: CellType.OfRadio },
    { id: 1, fieldName: 'deCpfCnpj', title: 'CPF/CNPJ', Component: CellType.OfDocumentNumber },
    { id: 2, fieldName: 'deNomePermissionario', title: 'Nome permissionário' },
    { id: 3, fieldName: 'nuPermissionario', title: 'Nº cadastro' },
];

export const selectMultiplePermissionaryColumn = [
    { id: 4, fieldName: 'cdLinhaPermissionario', title: '', Component: CellType.OfCheckBox },
    { id: 1, fieldName: 'deCpfCnpj', title: 'CPF/CNPJ', Component: CellType.OfDocumentNumber },
    { id: 2, fieldName: 'deNomePermissionario', title: 'Nome permissionário' },
    { id: 3, fieldName: 'nuPermissionario', title: 'Nº cadastro' },
];
//#endregion

//#region Tela de transferencias
export const transferColumns = [
    { id: 4, fieldName: 'nuProcesso', title: 'Nº Processo' },
    { id: 5, fieldName: 'nuTermoTransferencia', title: 'Nº Termo' },
    { id: 1, fieldName: 'dtTransferencia', title: 'Data transferência', Component: CellType.OfDate },
    // prettier-ignore
    {
    id: 2,
    fieldName: 'permissionarioAnterior',
    title: 'Permissionário anterior',
    Component: CellType.OfNestedObjectV2,
  },
    // prettier-ignore
    {
    id: 3,
    fieldName: 'permissionarioAtual',
    title: 'Permissionário atual',
    Component: CellType.OfNestedObjectV2,
  },
];

export const itinerarySectionsList = [
    { id: 0, fieldName: 'nuSecao', title: 'Seção', Component: CellType.OfNestedObject },
    { id: 1, fieldName: 'deLocalidade', title: 'Localidade', Component: CellType.OfNestedObject },
    { id: 2, fieldName: 'nuPisoUm', title: 'Piso I', Component: CellType.OfNestedObject },
    { id: 3, fieldName: 'nuPisoDois', title: 'Piso II', Component: CellType.OfNestedObject },
    { id: 4, fieldName: '', title: '', Component: CellType.OfNestedObject },
];

export const requestTransferDrawerColumns = [
    { id: 1, fieldName: 'cdSolicitacao', title: '', Component: CellType.OfRadio },
    { id: 2, fieldName: 'dtCadastro', title: 'Data / Solicitação' },
    { id: 3, fieldName: 'cdEmpresa', title: 'Identificação' },
    { id: 4, fieldName: 'nuSolicitacao', title: 'nº solicitação / processo' },
    { id: 5, fieldName: 'deSituacao', title: 'Situação' },
];
//#endregion

export const apostilleListColumns = [
    { id: 0, fieldName: 'nuApostilaFmt', title: 'Número' },
    { id: 1, fieldName: 'dtEmissao', title: 'Emissão' },
    { id: 2, fieldName: 'dtInicioValidade', title: 'Vigência' },
    { id: 3, fieldName: 'nuProcesso', title: 'Processo' },
    { id: 4, fieldName: 'nuSolicitacaoFmt', title: 'Solicitação' },
    { id: 5, fieldName: 'boInativada', title: 'Inativada', align: 'right', Component: CellType.OfActive },
];

export const selectBaseLegalAditamento = [
    { id: 0, fieldName: 'cdCodigo', title: '', Component: CellType.OfRadio },
    { id: 1, fieldName: 'deDescricao', title: 'Descrição' },
];

export const contractsListColumns = [
    { id: 0, fieldName: 'nuTermo', title: 'Número' },
    { id: 1, fieldName: 'deTipoContrato', title: 'Tipo' },
    { id: 2, fieldName: 'dtInicioVigencia', title: 'Data Início Vigência' },
    { id: 3, fieldName: 'dtVencimento', title: 'Data Vencimento' },
];

export const attachmentContractColumns = [
    {
        id: 1,
        fieldName: 'nuAnexoContrato',
        title: 'Nº documento',
        Component: CellType.OfTextField,
        maxSize: 10,
    },
    {
        id: 2,
        fieldName: 'nuSolicitacaoFmt',
        title: 'Nº solicitação',
        Component: CellType.OfRequestNumberInput,
    },
    {
        id: 4,
        fieldName: 'tipoDocumento',
        title: 'Tipo de documento',
        Component: CellType.OfSelectDocumentInput,
    },
    {
        id: 3,
        fieldName: 'documentos.fileName',
        title: 'Arquivos',
        Component: CellType.OfDocumentField,
    },
];
export const conductorDetailsPermissionariesTable = [
    { id: 0, fieldName: 'deCpfCnpj', title: 'CNPJ/CPF', Component: CellType.OfDocumentNumber },
    { id: 1, fieldName: 'deNomePermissionario', title: 'NOME PERMISSIONÁRIO' },
    { id: 2, fieldName: 'cdLinhaPermissionario', title: 'Nº CADASTRO' },
];
